import React, { useState } from "react";
import { ShoppingCart, Check } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { getHT, getTTC } from "@/lib/prices";
import AccessorySuggestionModal from "@/components/AccessorySuggestionModal";

export default function AddToCartButton({ product, variant, label = "Ajouter au panier", className = "", testId, variantClass = "primary", type = "mini-pelle" }) {
  const { addItem, setOpen: setCartOpen } = useCart();
  const [added, setAdded] = React.useState(false);
  const [showSuggest, setShowSuggest] = useState(false);

  const isRippaMiniPelle = type === "mini-pelle" && typeof product.slug === "string" && product.slug.startsWith("rippa-");

  const handleClick = () => {
    addItem({
      slug: product.slug,
      type,
      nom: product.modele || product.nom,
      prix_ht: getHT(product),
      prix_ttc: getTTC(product),
      image: product.image_principale || product.image,
    });
    setAdded(true);
    setTimeout(() => setAdded(false), 1500);
    if (isRippaMiniPelle) {
      setCartOpen(false);
      setShowSuggest(true);
    }
  };

  const base = variantClass === "primary" ? "lmb-btn-primary" : "lmb-btn-secondary";

  return (
    <>
      <button onClick={handleClick} data-testid={testId} className={`${base} ${className}`}>
        {added ? <Check size={16} /> : <ShoppingCart size={16} />}
        {added ? "Ajouté !" : label}
      </button>
      {isRippaMiniPelle && (
        <AccessorySuggestionModal
          open={showSuggest}
          onClose={() => setShowSuggest(false)}
          machineSlug={product.slug}
          machineName={product.modele || product.nom}
          variantName={variant?.nom || product.modele || ""}
        />
      )}
    </>
  );
}
